import React from 'react'
import {Context as AppContext} from '../../contexts/App'
import {Context as SalesChannelsContext} from '../../contexts/SalesChannels'
import ObjectForm from '../../components/ObjectForm'

import Button from '@mui/material/Button';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';

const GroupedSalesCreate = ({open, close, model, ...rest}) => {
  const { vendor } = React.useContext(AppContext)
  const { recall, setRecall, events } = React.useContext(SalesChannelsContext)
  const { uploadGroupedSale } = events

  const title = model?"Actualizar":"Añadir"
  console.log({model})
  return (
    <Dialog onClose={close} open={open}>
      <DialogTitle>{title}</DialogTitle>
      <ObjectForm ignored={[]} recall={recall} submit={uploadGroupedSale}
        stc={{ vendor: model?model.vendor:vendor, _id: model?model._id:null }}
        obj={{sales:''}}
        labels={{sales:'Ventas'}}
        types={{sales:'tag'}}
        changed={{...model} || {}} 
      />
      <Button onClick={() => {setRecall(true);close()}}>{title}</Button>
    </Dialog>
  )
}
export default GroupedSalesCreate